import { Skeleton } from '@/components/ui/skeleton';
import { LotSizingSupplierTableLineSkeleton } from '@/features/lot-sizing/skeleton/lot-sizing-supplier-table-line-skeleton';

export function LotSizingSupplierTableSkeleton() {
  return (
    <div className='mb-10 flex flex-col gap-4'>
      <div className='flex items-center justify-between gap-4'>
        <Skeleton className='h-7 w-40' />
        <Skeleton className='h-9 w-14 shrink-0' />
      </div>
      <div className='flex flex-col gap-4'>
        {Array.from({ length: 2 }, (_, i) => i).map((id) => (
          <LotSizingSupplierTableLineSkeleton key={id} />
        ))}
      </div>
    </div>
  );
}
